import type { Causa } from './api';

/**
 * De qué lado estuvo el error de una ejecución, con el nombre que se le dice a
 * quien mira y qué significa.
 *
 * Solo aplica a los `ERROR`: un proceso que el SDK cerró como `BUSINESS_ERROR`
 * ya trae su resultado propio. Esto sirve para decir qué llamada explica una
 * falla, y para reconocer los rechazos de clientes que todavía no actualizaron.
 */
export const CAUSAS: Record<Causa, { etiqueta: string; explicacion: string }> = {
  servicio: {
    etiqueta: 'Servicio',
    explicacion:
      'Falló un servicio: una llamada no obtuvo respuesta, devolvió un error 5xx, o un 4xx que no es operación normal.',
  },
  negocio: {
    etiqueta: 'Negocio',
    explicacion:
      'El servicio respondió y dijo que no: lo único que falló fueron códigos que el cliente declaró como operación normal, como el 409.',
  },
  otro: {
    etiqueta: 'Sin llamada fallida',
    explicacion:
      'Ninguna llamada falló: el proceso terminó mal por la propia aplicación, por una regla local o una excepción.',
  },
};
